'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);

function getErrorMessage(error) {
  var _error$data;
  var message = '';
  if (typeof error === 'string') {
    message = error;
  } else if (error !== null && error !== void 0 && (_error$data = error.data) !== null && _error$data !== void 0 && _error$data.message) {
    var _error$data2;
    message = (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.message;
  }
  return message;
}
function isSessionRevoked(data) {
  var _context;
  return _includesInstanceProperty__default["default"](_context = getErrorMessage(data).toLowerCase()).call(_context, 'session is revoked');
}
function isPasswordExpired(data) {
  var _context2;
  return _includesInstanceProperty__default["default"](_context2 = getErrorMessage(data).toLowerCase()).call(_context2, 'password has expired');
}
function handlePasswordExpired() {
  var redirectionURL = "/#/changepassword?returnURL=".concat(encodeURIComponent(window.location.pathname + window.location.search + window.location.hash));
  showErrorDialog("You password has expired", "Please change your password to continue.", redirectionURL);
}
function showSessionEndDialog() {
  var redirectionURL = "/#/login?returnURL=".concat(encodeURIComponent(window.location.pathname + window.location.search + window.location.hash), "&loggedOut=true");
  showErrorDialog('Your session has ended', 'Your session has been terminated due to a login from another device. For security reasons, we can only allow one active session per user at a time.', redirectionURL);
}
function showErrorDialog(title, content, redirectionURL) {
  if (document.querySelector('.dialog-overlay')) {
    return;
  }
  var overlay = document.createElement('div');
  overlay.classList.add('dialog-overlay');
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.32)';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.display = 'flex';
  overlay.style.alignItems = 'center';
  overlay.style.justifyContent = 'center';
  overlay.style.zIndex = '10000';
  var dialog = document.createElement('div');
  dialog.classList.add('dialog');
  dialog.style.backgroundColor = '#fff';
  dialog.style.padding = '20px';
  dialog.style.maxWidth = '400px';
  dialog.style.textAlign = 'center';
  dialog.style.boxShadow = '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)';
  dialog.style.borderRadius = '4px';
  dialog.style.color = 'rgba(0, 0, 0, 0.87)';
  var titleElem = document.createElement('h2');
  titleElem.textContent = title;
  titleElem.style.marginTop = '0';
  titleElem.style.font = '500 20px/32px Roboto, "Helvetica Neue", sans-serif';
  var contentElem = document.createElement('p');
  contentElem.textContent = content;
  contentElem.style.marginBottom = '20px';
  contentElem.style.font = '400 14px/20px Roboto, "Helvetica Neue", sans-serif';
  var confirmButton = document.createElement('button');
  confirmButton.textContent = 'CONFIRM';
  confirmButton.style.padding = '10px 20px';
  confirmButton.style.background = 'transparent';
  confirmButton.style.color = '#d50000';
  confirmButton.style.border = 'none';
  confirmButton.style.cursor = 'pointer';
  confirmButton.style.font = '500 14px Roboto, "Helvetica Neue", sans-serif';
  confirmButton.style.borderRadius = '4px';
  dialog.appendChild(titleElem);
  dialog.appendChild(contentElem);
  dialog.appendChild(confirmButton);
  overlay.appendChild(dialog);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';
  confirmButton.addEventListener('click', onClick);
  function onClick() {
    window.location.href = redirectionURL;
  }
}

exports.handlePasswordExpired = handlePasswordExpired;
exports.isPasswordExpired = isPasswordExpired;
exports.isSessionRevoked = isSessionRevoked;
exports.showErrorDialog = showErrorDialog;
exports.showSessionEndDialog = showSessionEndDialog;
